(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('BrokerageLocation', BrokerageLocation);

    BrokerageLocation.$inject = ['$resource'];

    function BrokerageLocation ($resource) {
        var resourceUrl =  'api/brokerage-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getDropDownBrokerageLocations': { method:'GET', url:'api/brokerage-locations-minimal', isArray: true }
        });
    }
})();
